export default __webpack_public_path__ + "static/core1-c911b6117278149987278f3fcd738b2f.jpg";